import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
pageRoot: {
    backgroundColor: theme.palette.bgColor.main,
    position: 'relative',
    //color: theme.palette.textColor.main,
},
experienceTitle:{
    textAlign: 'center',
    fontSize: '2em',
    fontWeight: 400,
    color: '#FFFFFF',
    margin: '1.5em',
},
EdTitle:{
    textAlign: 'center',
    fontSize: '2em',
    fontWeight: 400,
    color: '#FFFFFF',
    margin: '1.5em',
},
projectSection:{
    textAlign: 'center',
    fontSize: '2em',
    fontWeight: 400,
    color: '#FFFFFF',
    marginTop: '1.5em',
    marginBottom: '15px'
},
section2: {
    padding: '1em 5em',
    backgroundImage: "linear-gradient(to bottom, #282336, #282336), url('../../assets/images/pexels-markus-spiske-177598.jpg')",
    height: '100%',
    backgroundSize: 'cover',
    [theme.breakpoints.down('xs')]: {
         padding: '1em 2em',
    }
},
projectCardWrap: {
    height: 300,
    display: 'flex',
    alignItems: 'center',
    gap: 15,
    overflowX: 'scroll',
},
}))

export {useStyles}